import { useEffect, useState } from "react"

import { firebaseService } from "@callcenter-frontend/services"

export const useEnableMobileNotifications = () => {
  const [isEnabledMobileNotifications, setEnabledMobileNotifications] = useState(false)

  const requestMobilePermission = async () => {
    if (isEnabledMobileNotifications) {
      try {
        const granted = await firebaseService.requestNotificationPermission()

        if (granted) {
          const token = await firebaseService.getFCMToken()

          if (token) {
            await firebaseService.sendTokenToServer(token)
            await firebaseService.initFirebaseService()
          }
        }
      } catch (error) {
        console.error("Failed to request notification permission:", error)
      }
    } else {
      await firebaseService.deleteSWRegistration()
    }
  }

  useEffect(() => {
    const checkSWRegistration = async () => {
      if (!("serviceWorker" in navigator) || !("Notification" in window) || Notification.permission !== "granted") {
        setEnabledMobileNotifications(false)

        return
      }

      const registrations = await navigator.serviceWorker.getRegistrations()
      const hasFirebaseSW = registrations.some((r) => r.active?.scriptURL.includes("webapp-sw"))

      setEnabledMobileNotifications(hasFirebaseSW)
    }

    checkSWRegistration()
  }, [])

  return {
    requestMobilePermission,
    isEnabledMobileNotifications,
    setEnabledMobileNotifications
  }
}
